module.exports = __webpack_public_path__ + "static/media/homebg.2640a48e.png";